import { render } from "./Reset.vue?vue&type=template&id=e8b623ba"
import script from "./Reset.vue?vue&type=script&lang=js"
export * from "./Reset.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\msimi\\Downloads\\DEVAREA\\OFFICE\\pvmi-coaching-web-report\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__